// Mobile "View" toggle: reveals the list of products attached to a look card.
if (!window.__wofLookViewBound) {
  window.__wofLookViewBound = true;
  document.addEventListener('click', (event) => {
    // Close (✕) button inside the overlay
    const closeBtn = event.target.closest('.wof-look__view-close');
    if (closeBtn) {
      const panel = closeBtn.closest('.wof-look__view-panel');
      if (panel) {
        panel.hidden = true;
        document.querySelector(`[aria-controls="${panel.id}"]`)?.setAttribute('aria-expanded', 'false');
      }
      return;
    }

    const toggle = event.target.closest('.wof-look__view-toggle');
    if (!toggle) return;
    const panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!panel) return;
    const isOpen = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!isOpen));
    panel.hidden = isOpen;
  });
}

if (!customElements.get('shop-look-button')) {
  customElements.define(
    'shop-look-button',
    class ShopLookButton extends HTMLElement {
      connectedCallback() {
        if (this._bound) return;
        this._bound = true;
        // Bind on the element itself — its child <button> may not be parsed yet
        // when this custom element upgrades during HTML parsing.
        this.addEventListener('click', (event) => {
          const button = event.target.closest('.wof-look__button');
          if (button) this.onClick(event, button);
        });
      }

      async onClick(event, button) {
        event.preventDefault();

        const ids = (button.dataset.lookItems || '')
          .split(',')
          .map((value) => value.trim())
          .filter(Boolean);
        if (!ids.length) return;

        this.setLoading(button, true);

        try {
          // Resolve the cart drawer, waiting for it to upgrade if it's in the DOM but not yet defined.
          let cart = document.querySelector('cart-drawer');
          if (cart && typeof cart.renderContents !== 'function' && window.customElements) {
            try {
              await customElements.whenDefined('cart-drawer');
            } catch (e) {
              /* ignore */
            }
            cart = document.querySelector('cart-drawer');
          }

          // Mirror the theme's product-form flow exactly (FormData + items[] + javascript config).
          const config =
            typeof fetchConfig === 'function'
              ? fetchConfig('javascript')
              : { method: 'POST', headers: {} };
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

          const formData = new FormData();
          ids.forEach((id, index) => {
            formData.append(`items[${index}][id]`, id);
            formData.append(`items[${index}][quantity]`, '1');
          });

          if (cart && typeof cart.getSectionsToRender === 'function') {
            const sectionsToRender = cart.getSectionsToRender().map((section) => section.id);
            formData.append('sections', sectionsToRender);
            formData.append('sections_url', window.location.pathname);
            cart.setActiveElement?.(document.activeElement);
          }

          config.body = formData;

          const url = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
          const response = await fetch(url, config);
          const data = await response.json();

          if (data.status) {
            console.error('Shop the look could not be added to cart:', data.description || data.message);
            return;
          }

          if (cart && typeof cart.renderContents === 'function') {
            cart.renderContents(data);
          } else if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            // No drawer reference — let any cart drawer/notification react to the update.
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'shop-look-button', cartData: data });
          } else {
            window.location = (window.routes && window.routes.cart_url) || '/cart';
          }
        } catch (error) {
          console.error('Shop the look could not be added to cart:', error);
        } finally {
          this.setLoading(button, false);
        }
      }

      setLoading(button, isLoading) {
        button.classList.toggle('loading', isLoading);
        button.toggleAttribute('aria-disabled', isLoading);
        button.querySelector('.loading__spinner')?.classList.toggle('hidden', !isLoading);
      }
    }
  );
}
